import { get, post } from "../request.js";
import { useGlobalStore } from "../../store/modules/global";

export const ApiGetClassInfo = {
  get: (cid) => {
    return get(`/class/kindofres/${cid}`);
  },
};

export const ApiGetBroadcast = {
  get: (cid) => {
    return get(`/class/broadcast/content/${cid}`);
  },
};

export const ApiGetOnlineMember = {
  get: (cid) => {
    return get(`/class/onlinemate/${cid}`);
  },
};

export const ApiUseBroadcast = {
  get: async (cid, bid) => {
    const global = useGlobalStore();
    let result = await get(`/class/broadcast/use/${cid}/${bid}`);
    // console.log("use Broadcast result", result);
    if (result.status === "success") {
      global.$patch((state) => {
        state.alert.show = true;
        state.alert.message = "Use broadcast successfully";
        state.alert.status = "success";
        setTimeout(() => {
          state.alert.show = false;
        }, 4000);
      });
    }
    return result;
  },
};
export const ApiGetClassResource = {
  get: (cid, note, filter) => {
    return get(`/class/resource/list/${cid}/${note}?filter=${filter}`);
  },
};

export const ApiGetClassResourceDetail = {
  get: (cid, rid) => {
    return get(`/class/resource/detail/${cid}/${rid}`);
  },
};

export const ApiGetUsableBroadcast = {
  get: () => {
    return get(`/class/broadcast/list`);
  },
};

export const ApiClassResSearch = {
  get: (cid, keyword, start, order, sort, src) => {
    return get(
      `/class/search/${cid}/${keyword}?start=${start}&order=${order}&sort=${sort}&src=${src}`
    );
  },
};

export const ApiGetResourceInfo = {
  get: (rid) => {
    return get(`/utility/resmeta/${rid}`);
  },
};

// 添加邀請碼驗證API
export const ApiValidateInvitationCode = {
  validate: (code) => {
    return post("/validate_invitation_code", { code });
  },
};

// 添加註冊並加入班級API
export const ApiRegisterAndJoinClass = {
  register: (data) => {
    // 確保 patternPw 保持為原始 emoji 字符
    // 為了防止 JSON.stringify 將 emoji 轉為 Unicode 轉義序列
    // 保留 API 請求原本的 data 結構
    return post("/register_and_join_class", data);
  },
};

// 添加學生訂閱API
export const ApiAddStudentSubscription = {
  add: (data) => {
    console.log("add_student_subscription data", data);
    return post("/add_student_subscription", data);
  },
};

// 獲取學生訂閱狀態API
export const ApiGetStudentSubscriptionStatus = {
  get: (studentId) => {
    return get(`/student_subscription_status/${studentId}`);
  },
};
